module.exports = __webpack_public_path__ + "img/panneau-grillage-full.f785cea.svg";